// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import { Button } from "react-bootstrap";
// import {
//   IconCircleCheckFilled,
//   IconTrash,
//   IconUserOff,
// } from "@tabler/icons-react";
// import { API_ENDPOINTS } from "../../constant/_constant";
// import usePostRequest from "../../hooks/usePostRequest";
// import { toast } from "react-toastify";

// function ContractCard({ key, contract, handleEditContract, refetchContracts }) {
//   console.log("ContractCard rendered");
//   const user = useSelector((state) => state.auth.user);
//   const [editLoading, setEditLoading] = useState(false);
//   const [isUpdated, setisUpdated] = useState(null);
//   const handleEditClick = (contract) => {
//     setEditLoading(true);
//     setTimeout(() => {
//       handleEditContract(contract);
//       setEditLoading(false);
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     }, 400);
//   };

//   const {
//     data,
//     isLoading,
//     postData: changeStatus,
//   } = usePostRequest(API_ENDPOINTS.CHANGE_CONTRACT_STATUS);

//   const userPermissions = user?.permissions?.manage_rfq || [];
//   const hasPermission = (permissionArray, permissionType) =>
//     permissionArray.includes(permissionType);
//   const canDeleteContract = hasPermission(userPermissions, "delete");
//   const canWriteContract = hasPermission(userPermissions, "write");
//   //   const canAssignRole = canWriteRole

//   const handleChangeStatus = () => {
//     const newStatus = !contract.status;
//     const payload = {
//       status: newStatus,
//       name: contract.name,
//     };

//     changeStatus(
//       payload,
//       (response) => {
//         toast.success(response.message);
//         refetchContracts?.();
//         setisUpdated(response?.status);
//       },
//       (error) => {
//         // console.error(`Error changing status for ${contract.name}:`, error);
//         toast.error(error?.message || `Error updating status`);
//       }
//     );
//   };

//   return (
//     <div key={key} className="col-sm-6 col-lg-3 mb-4">
//       <div className="card card-md h-100">
//         <div
//           className="ribbon ribbon-top ribbon-bookmark"
//           //   style={{ backgroundColor: role?.color }}
//         >
//           {contract?.letter}
//         </div>
//         <div className="user_status_info position-relative" style={{right:"-8px", top:"8px"}}>
//           <span
//             className={`${
//               contract?.status
//                 ? "badge_card bg-green-lt"
//                 : "badge_card bg-yellow-lt"
//             }`}
//           >
//             {contract?.status ? (
//               <>
//                 <IconCircleCheckFilled /> Active
//               </>
//             ) : (
//               <>
//                 <IconUserOff /> Inactive
//               </>
//             )}
//           </span>
//         </div>

//         <div className="card-body pb-5">
//           <h4 className="card_heading">{contract?.name}</h4>
//           <div className="my-3">
//             {contract.contracting_emails && (
//               <div className="emails-highlight">
//                 {contract.contracting_emails.split(",").map((email, index) => (
//                   <p className="mb-0 badge bg-blue-lt" key={index}>
//                     {email.trim()}
//                   </p>
//                 ))}
//               </div>
//             )}
//             <p>{contract?.description}</p>
//           </div>
//           <div className="d-flex gap-2 button_group pt-0">
//             {canWriteContract && (
//               <Button
//                 size="sm"
//                 className="flex-1"
//                 // style={{ backgroundColor: role?.color }}
//                 onClick={() => handleEditClick(contract)}
//               >
//                 {editLoading ? "Loading..." : " Edit"}
//               </Button>
//             )}
//             {canDeleteContract && (
//               <Button
//                 size="sm"
//                 className="flex-1"
//                 variant={contract.status ? "outline-danger" : "outline-success"}
//                 onClick={handleChangeStatus}
//               >
//                 {contract.status ? "Deactivate" : "Activate"}
//               </Button>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default React.memo(ContractCard);

import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import {
  IconCircleCheckFilled,
  IconTrash,
  IconUserOff,
} from "@tabler/icons-react";
import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import { toast } from "react-toastify";

function ContractCard({ contract, handleEditContract }) {
  console.log("ContractCard rendered");

  const user = useSelector((state) => state.auth.user);

  const [editLoading, setEditLoading] = useState(false);
  const [isUpdated, setIsUpdated] = useState(contract?.status);

  const {
    postData: changeStatus,
    isLoading: statusLoading,
  } = usePostRequest(API_ENDPOINTS.CHANGE_CONTRACT_STATUS);

  const userPermissions = user?.permissions?.manage_rfq || [];

  const hasPermission = (permissionArray, permissionType) =>
    permissionArray.includes(permissionType);

  const canDeleteContract = hasPermission(userPermissions, "delete");
  const canWriteContract = hasPermission(userPermissions, "write");

  const handleEditClick = () => {
    setEditLoading(true);
    setTimeout(() => {
      handleEditContract(contract);
      setEditLoading(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 400);
  };

  const handleChangeStatus = () => {
    const newStatus = !isUpdated;

    const payload = {
      status: newStatus,
      name: contract.name,
    };

    changeStatus(
      payload,
      (response) => {
        toast.success(response.message);
        setIsUpdated(response?.status);
      },
      (error) => {
        toast.error(error?.message || "Error updating status");
      }
    );
  };

  return (
    <div className="col-sm-6 col-lg-3 mb-4">
      <div className="card card-md h-100">
        <div className="ribbon ribbon-top ribbon-bookmark">
          {contract?.letter}
        </div>

        <div
          className="user_status_info position-relative"
          style={{ right: "-8px", top: "8px" }}
        >
          <span
            className={`badge_card ${
              isUpdated ? "bg-green-lt" : "bg-yellow-lt"
            }`}
          >
            {isUpdated ? (
              <>
                <IconCircleCheckFilled /> Active
              </>
            ) : (
              <>
                <IconUserOff /> Inactive
              </>
            )}
          </span>
        </div>

        <div className="card-body pb-5">
          <h4 className="card_heading">{contract?.name}</h4>
          <div className="my-3">
            {contract.contracting_emails && (
              <div className="emails-highlight">
                {contract.contracting_emails
                  .split(",")
                  .map((email, index) => (
                    <p className="mb-0 badge bg-blue-lt" key={index}>
                      {email.trim()}
                    </p>
                  ))}
              </div>
            )}
            <p>{contract?.description}</p>
          </div>
          <div className="d-flex gap-2 button_group pt-0">
            {canWriteContract && (
              <Button size="sm" className="flex-1" onClick={handleEditClick}>
                {editLoading ? "Loading..." : "Edit"}
              </Button>
            )}
            {canDeleteContract && (
              <Button
                size="sm"
                className="flex-1"
                variant={isUpdated ? "outline-danger" : "outline-success"}
                onClick={handleChangeStatus}
                disabled={statusLoading}
              >
                {statusLoading
                  ? "Updating..."
                  : isUpdated
                  ? "Deactivate"
                  : "Activate"}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(ContractCard);
